import qs from 'qs'

import { getListingStatusFilterState } from 'app/features/teams/messages/table-filters/MgmtTypeActionsFilter'
import { getPodsFilterState } from 'app/features/teams/messages/table-filters/PodsFilter'
import { getManagerFilterState } from 'app/features/teams/messages/table-filters/PropertyManagerFilter'
import {
  getCorrespondingMgmtTypeValue,
  getMgmtTypeFilterState,
} from 'app/pages/teams/messages'
import * as sharedHelpers from 'app/shared_components/helpers'
import { apiBaseUrl } from 'app/shared_components/shared_base_url'
import * as Features from 'config/features'

export const getTeamApplications = (agencyID, filters) => {
  const defaultedFilters = {
    archived: false,
    cursor: '',
    manager: '',
    limit: 10,
    searchText: '',
    applicantEmail: '',
    mgmtType: 0,
    ...filters,
  }
  const {
    searchText,
    manager,
    pods,
    mgmtType,
    teamSlug = '',
    accountType,
    includeListingStatusFilter,
    ...otherFilters
  } = defaultedFilters
  let mappedFilters = {
    ...otherFilters,
    q: searchText,
  }

  let searchParams = new URLSearchParams()
  const podsFilter = getPodsFilterState(pods)
  const managerFilter = getManagerFilterState(manager)
  managerFilter?.forEach((managerGUID) =>
    searchParams.append('manager', managerGUID),
  )
  podsFilter?.forEach((podId) => searchParams.append('pods', podId))

  const mgmtTypeFilter = getCorrespondingMgmtTypeValue(
    getMgmtTypeFilterState(mgmtType),
  )
  const listingStatusFilter =
    includeListingStatusFilter ??
    Features.isPMPropertyListingFilterEnabled(teamSlug, accountType)
      ? getListingStatusFilterState(mgmtType)
      : undefined

  mgmtTypeFilter?.forEach((val) => searchParams.append('mgmtType', val))
  listingStatusFilter?.forEach((val) =>
    searchParams.append('listingStatus', val),
  )

  let filtersQuery = searchParams.toString()

  filtersQuery += `&${qs.stringify(mappedFilters, { arrayFormat: 'repeat' })}`
  const url = `${apiBaseUrl}sm/teams/${agencyID}/applications?${filtersQuery}`
  const options = {
    method: 'GET',
    credentials: 'include',
  }
  return fetch(url, options)
    .then(sharedHelpers.checkStatus)
    .then(
      (responseData) => ({ ok: true, responseData }),
      sharedHelpers.returnAPIError,
    )
    .catch(sharedHelpers.logAPIError)
}
